import React, { useCallback, useEffect, useState } from 'react'
import { Button, Row, Col } from 'react-bootstrap/'
import { useCart } from 'react-use-cart'
import { Link } from 'react-router-dom'
import { Icon } from '../../components'
import { useDispatch, useSelector } from 'react-redux'
import { setDiscountInfo } from '../../slices/uiSlice'
import { data } from '../../data'
    
import './cart.scss'

export const Cart = () => {
    const dispatch = useDispatch()
    const { discountInfo } = useSelector((state: any) => state.ui)
    const [isExistCode, setIsExistCode] = useState<any>(null)

    const { 
        isEmpty,
        totalUniqueItems,
        totalItems,
        items,
        updateItemQuantity,
        removeItem,
        cartTotal,
        emptyCart,
    } = useCart()

    const handleDiscountInfo = useCallback((info: any) => {
        
        setIsExistCode(info ? true : false)
        dispatch(setDiscountInfo(info))
        sessionStorage.setItem('discountInfo', JSON.stringify(info))
    },[dispatch])

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    },[])

    useEffect(() => {
        discountInfo && setIsExistCode(true)
    },[discountInfo])

    useEffect(() => {
        discountInfo && handleDiscountInfo({price: cartTotal - ((cartTotal * discountInfo.percent)/100), percent:  discountInfo.percent, discountCode: discountInfo.discountCode})
    },[cartTotal])

    if (isEmpty) {return <h4 className='empty-cart'>Кошничката е празна!</h4>}

    else {
        return (
        <>  
            <h4 className='your-order'>ВАШАТА ПОРЪЧКА</h4>
            <hr />
            <span>■</span>
            <div className='ordersList'>
                
                {
                    !isEmpty && 
                    <div className='header'>
                        <p style={{width: '19%'}}></p>
                        <p style={{width: '25%'}}>Продукт</p>
                        <p style={{width: '19%'}}>Цена</p>
                        <p style={{width: '19%'}}>Брой</p>
                        <p style={{width: '19%'}}>Общо</p>
                    </div>
                }
                    
                {items.map((product: any, index: any) => (
                    <div className='cart-item' key={index}>
                        <div>
                            <button type="button" className="btn-close delete-for-fone" aria-label="Close" title='изтрий' onClick={() => removeItem(product.id)}></button>
                        </div>
                        <img src={product.img} alt={product.title} className='product-img' />
                        <p className='my-auto product-title'>{product.title}</p>

                        <div className='info-section-for-phone'>
                            <div>
                                <p>Цена</p>
                                <p>Брой</p>
                                <p>Общо</p>
                            </div>
                            <div>
                                <p className='my-auto'>{(product.price / 1.95583).toFixed(2)}€/<br/>{product.price.toFixed(2)}лв</p>
                                <p className='my-auto'>
                                    <div className='quantity'>
                                        <Button className='btn-sm mx-1 quantity-btn' variant="outline-dark" onClick={() => updateItemQuantity(product.id, product.quantity - 1)}>-</Button>
                                        <Button className='btn-sm mx-1 quantity-btn' variant="outline-dark" >{product.quantity}</Button>
                                        <Button className='btn-sm mx-1 quantity-btn' variant="outline-dark" onClick={() => updateItemQuantity(product.id, product.quantity + 1)}>+</Button>
                                    </div>
                                </p>
                                <p className='my-auto'>{(product.itemTotal / 1.95583).toFixed(2)}€/<br/>{product.itemTotal?.toFixed(2)}лв</p>
                            </div>
                        </div>

                        <p className='my-auto for-desktop'>{(product.price / 1.95583).toFixed(2)}€/<br/>{product.price.toFixed(2)}лв</p>
                        <div className='quantity my-auto for-desktop'>
                            <Button className='btn-sm mx-1 quantity-btn' variant="outline-dark" onClick={() => updateItemQuantity(product.id, product.quantity - 1)}>-</Button>
                            <Button className='btn-sm mx-1 quantity-btn' variant="outline-dark" >{product.quantity}</Button>
                            <Button className='btn-sm mx-1 quantity-btn' variant="outline-dark" onClick={() => updateItemQuantity(product.id, product.quantity + 1)}>+</Button>
                        </div>
                        <p className='my-auto  for-desktop'>{(product.itemTotal / 1.95583).toFixed(2)}€/<br/>{product.itemTotal?.toFixed(2)}лв</p>
                        <button type="button" className="btn-close for-desktop" aria-label="Close" title='изтрий' onClick={() => removeItem(product.id)}></button>
                    </div>
                ))}
            </div>
            {
                !isEmpty && 
                    <div className='actions'>
                        
                        <div className='delete-section'>
                            <Button onClick={() => emptyCart()} >
                                <Icon
                                    iconName='Trash3'
                                    size={20}
                                />
                                Изтрий всички
                            </Button>
                        </div>
                            <p>
                                Общо: 
                                <span>
                                    {(cartTotal / 1.95583).toFixed(2)}€/{cartTotal?.toFixed(2)}лв
                                </span>
                            </p>
                        {/* </div> */}

                        <div className='complete-order'>
                            <Link to='/complete-order?activePage=null'>
                                <Button>
                                    Завършете поръчката
                                    <Icon
                                        iconName='ArrowRight'
                                        size={20}
                                    />
                                </Button>
                            </Link>
                        </div>
                    </div>
            }
            
        </>
        
        )
    }
}
